enum BI_EVENTS_TYPE {
    SELLER_INFO_DISPLAY_MORE_INFO_IS_SHOWN = 'seller_info_display.more_info_is_shown',
    SELLER_INFO_DISPLAY_CLICKED_ON_ENTRY_POINT = 'seller_info_display.clicked_on_entry_point',
    SELLER_INFO_DISPLAY_CLICKED_ON_OPT_IN = 'seller_info_display.clicked_on_opt_in',
    SELLER_INFO_DISPLAY_INFO_IS_SHOWN = 'seller_info_display.info_is_shown',
    SELLER_INFO_DISPLAY_CLICKED_ON_MESSAGE_SELLER = 'seller_info_display.clicked_on_message_seller',
    SELLER_INFO_DISPLAY_CLICKED_ON_SHOW_DETAIL = 'seller_info_display.clicked_on_show_detail',
}

enum BI_DSA_TYPE {
    UNKNOWN = 'unknown',
    TRADER = 'trader',
    NON_TRADER = 'non_trader',
}

const BASE_BI_EVENT = {
    group: 'seller_info_display',
    platform: 'web',
};

const BASE_BI_EVENT_CLICK = {
    ...BASE_BI_EVENT,
    page: {
        name: 'seller_page',
        element: {
            type: 'button',
        },
    },
    action: {
        type: 'click',
    },
};

const BASE_BI_EVENT_SHOW = {
    ...BASE_BI_EVENT,
    page: {
        name: 'seller_page',
    },
    action: {
        type: 'page view',
    },
};

const BASE_BI_EVENT_IMPRESSION = {
    page: {
        name: 'seller_page',
    },
    group: 'components_impressions',
    action: {
        type: 'impression',
    },
    platform: 'web',
};

export const BI_EVENT_SELLER_INFO_DISPLAY_CLICKED_ON_ENTRY_POINT = {
    ...BASE_BI_EVENT_CLICK,
    type: BI_EVENTS_TYPE.SELLER_INFO_DISPLAY_CLICKED_ON_ENTRY_POINT,
    seller: {
        dsa_type: BI_DSA_TYPE.TRADER,
    },
};

export const BI_EVENT_SELLER_INFO_DISPLAY_CLICKED_ON_OPT_IN = {
    ...BASE_BI_EVENT_CLICK,
    type: BI_EVENTS_TYPE.SELLER_INFO_DISPLAY_CLICKED_ON_OPT_IN,
    seller: {
        dsa_type: BI_DSA_TYPE.TRADER,
    },
};

export const BI_EVENT_SELLER_INFO_DISPLAY_CLICKED_ON_MESSAGE_SELLER = {
    ...BASE_BI_EVENT_CLICK,
    type: BI_EVENTS_TYPE.SELLER_INFO_DISPLAY_CLICKED_ON_MESSAGE_SELLER,
    seller: {
        dsa_type: BI_DSA_TYPE.TRADER,
    },
};

const BI_EVENT_SELLER_INFO_DISPLAY_INFO_IS_SHOWN_FIELD_NAMES = {
    phone_number: 'phone',
    email: 'email',
    business_number: 'business_registration_number',
};

export const generateBiEventClickedOnShowDetail = (field) => ({
    ...BASE_BI_EVENT_CLICK,
    type: BI_EVENTS_TYPE.SELLER_INFO_DISPLAY_CLICKED_ON_SHOW_DETAIL,
    seller: {
        dsa_type: BI_DSA_TYPE.TRADER,
    },
    kybc: {
        seller_info_display: {
            detail_type: BI_EVENT_SELLER_INFO_DISPLAY_INFO_IS_SHOWN_FIELD_NAMES[field],
        },
    },
});

export const BI_EVENT_SELLER_INFO_DISPLAY_MORE_INFO_IS_SHOWN = {
    ...BASE_BI_EVENT_IMPRESSION,
    type: BI_EVENTS_TYPE.SELLER_INFO_DISPLAY_MORE_INFO_IS_SHOWN,
    seller: {
        dsa_type: BI_DSA_TYPE.TRADER,
    },
};
export const BI_EVENT_SELLER_INFO_DISPLAY_INFO_IS_SHOWN = {
    ...BASE_BI_EVENT_SHOW,
    type: BI_EVENTS_TYPE.SELLER_INFO_DISPLAY_INFO_IS_SHOWN,
    seller: {
        dsa_type: BI_DSA_TYPE.TRADER,
    },
};
